// Unpublished Work © 2025 Deere & Company.

import {
    commonErrorAction,
    ErrorHandlerConfig,
} from '../App/utils/errorMessages';

export const boundariesError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};

export const fieldsError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};

export const hasFieldsError: ErrorHandlerConfig = {
    customAction: (error, query) => commonErrorAction(error, query),
};
